import type { NormalizedMarketRow } from '@/types/market';
import type { ScoreBand } from '@/types/insights';
import { clamp, pctChange } from '@/utils/numbers';
import { temperatureBand } from './bands';

/**
 * sellSpeedShift: how much faster (positive) or slower (negative) homes are
 * selling vs. the prior period, for THIS geography specifically -- a
 * trajectory signal, not a relative-rank signal. A falling median DOM is
 * "speeding up" (positive/hot); a rising DOM is "slowing down" (negative/cold).
 */
export function computeSellSpeedShift(row: NormalizedMarketRow): ScoreBand {
  const change = pctChange(row.medianDaysOnMarket, row.medianDaysOnMarketPrevPeriod);
  if (change === undefined) return temperatureBand(undefined);
  // Invert sign: DOM going up = slowing down = should read as a negative/cold shift.
  const scaled = clamp(-change, -100, 100);
  return temperatureBand(scaled);
}
